<a routerLink="/">
  <image
    url="https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/logo.webp"
    alt="Toniclub Logo"
    [priority]="true"
    [showBorder]="false"
    class="aspect-[8/9] w-48" />
</a>

@if (user()) {
<user-profile-badge [user]="user()!" />
}

<button
  [clicks]="'sidebar-notificaciones'"
  class="preset-body-1 border-primary-300 flex w-full shrink-0 cursor-pointer items-center gap-4 rounded-full border px-2 py-1 text-neutral-100">
  <img
    class="aspect-square size-8"
    src="https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/notifications.svg"
    alt="Botón de notificaciones" />
  Notificaciones
</button>

<section class="mt-8 flex h-full w-full flex-col gap-6 pl-6">
  @for (item of navItems(); track $index) { @if (item.extras) {
  <button
    class="text-primary-300 flex items-center gap-4 text-left transition-colors duration-300 hover:text-white"
    cdkOverlayOrigin
    [clicks]="'sidebar-nav-' + item.label"
    [preventDefault]="false"
    (click)="isOpen.set(!isOpen())">
    <icon-app
      class="w-7"
      [name]="isOpen() ? item.active_icon : item.inactive_icon" />
    <span
      class="preset-title-4"
      [class.text-white]="isOpen()">
      {{ item.label }}
    </span>
  </button>
  } @else {
  <a
    class="text-primary-300 flex items-center gap-4 text-left transition-colors duration-300 hover:text-white"
    [routerLink]="item.route"
    [clicks]="'sidebar-nav-' + item.label">
    <icon-app
      class="w-7"
      [name]="isActive(item.route!) ? item.active_icon : item.inactive_icon" />
    <span
      class="preset-title-4"
      [class.text-white]="isActive(item.route!)">
      {{ item.label }}
    </span>
  </a>
  } }

  <button
    data-test="logout"
    (click)="logout()"
    [clicks]="'sidebar-cerrar-sesion'"
    [preventDefault]="false"
    class="preset-body-1 text-primary-300 mt-auto flex cursor-pointer items-center gap-4 transition-colors">
    <icon-app
      class="w-7"
      name="signout" />

    Cerrar sesión
  </button>
</section>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger()!"
  [cdkConnectedOverlayOpen]="isOpen()"
  [cdkConnectedOverlayHasBackdrop]="true"
  cdkConnectedOverlayBackdropClass="bg-black/30"
  [cdkConnectedOverlayPositions]="[
    { originX: 'start', originY: 'bottom', overlayX: 'start', overlayY: 'top', offsetY: 8 },
    { originX: 'start', originY: 'top', overlayX: 'start', overlayY: 'bottom', offsetY: -8 }
  ]"
  (backdropClick)="isOpen.set(false)"
  (detach)="isOpen.set(false)">
  <extras-dropdown (selected)="isOpen.set(false)" />
</ng-template>
